export default __webpack_public_path__ + "static/error-d4c3940735ea01cd7b3865ceb378b98f.jpg";